import Button from '@/external/components/Button';
import getCdnImg from '@/shared/cdn/getCdnImg';
import Img from '@/shared/components/Img';

type Props = {
  currency?: string;
  action: string;
  fullWidth?: boolean;
};

const FundsButtonContent: FC<Props> = ({
  currency,
  action,
  fullWidth,
  children,
}) => {
  switch (action) {
    case 'deposit': {
      return (
        <Button
          variant="primary"
          size="sm"
          fullWidth={fullWidth}
          id={`${action}_${currency}`}
        >
          {children}
        </Button>
      );
    }
    case 'withdraw': {
      return (
        <Button
          variant="secondary"
          size="sm"
          fullWidth={fullWidth}
          id={`${action}_${currency}`}
        >
          {children}
        </Button>
      );
    }
    case 'exchange': {
      return (
        <Button
          className="h-8 p-0 rem:min-w-[32px]"
          variant="secondary"
          size="sm"
          id={`${action}_${currency}`}
        >
          <Img src={getCdnImg(`/icons/exchange.svg`)} alt="" />
        </Button>
      );
    }
    default: {
      return null;
    }
  }
};

export default FundsButtonContent;
